export default {
  methods: {
    keyToArr(key) {
      const lastSlash = key.substr(key.length - 1) === '/'
      return lastSlash ? key.slice(0, -1).split('/') : key.split('/')
      // return key.split('/').filter(item => item)
    },
    formatObjectName(key) {
      const tempHelperArr = this.keyToArr(key)
      return tempHelperArr[tempHelperArr.length - 1] || '[Empty name]'
    },
  },
}
